import momenJalaali from "moment-jalali";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker2";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import BihamtaTable from "../../Components/BihamtaTable";
import { setDialog } from "../../store/api/GetAllProduct";
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import { exportToExcel, invoiceTypesArray, isMobileApp } from "../../store/api/CommonFunctions";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Printer, Search } from "react-bootstrap-icons";
import { deleteInvoice, getInvoiceStates, getSystemSettings, searchInvoices } from "../store/api/Invoice";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBroom, faSearch } from '@fortawesome/free-solid-svg-icons';
import NewNumberInput from "../../Components/NewNumberInput";

const SearchInvoice = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const filterData = useSelector(state => state.InvoiceReducer.invoiceSearchFilters)
    const [dateFilters, setDateFilters] = useState({
        ContactDateFrom: filterData?.ContactDateFrom,
        ContactDateTo: filterData?.ContactDateTo,
        CreationDateFrom: filterData?.CreationDateFrom,
        CreationDateTo: filterData?.CreationDateTo,
        UpdateDateFrom: filterData?.UpdateDateFrom,
        UpdateDateTo: filterData?.UpdateDateTo
    });
    const { handleSubmit, register } = useForm();
    const [pending, setPending] = useState(false);
    const [updateBy, setUpdateBy] = useState(null);
    const [createBy, setCreateBy] = useState(null);
    const [showFilter, setShowFilter] = useState(true);
    const [selectedStaff, selectStaff] = useState(null);
    const [destStorage, setDestStorage] = useState(null);
    const [invoiceStates, setInvoiceStates] = useState([]);
    const [popUser, setPopUser] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState(null);
    const [popStaff, setPopStaff] = useState({ show: false });
    const [sourceStorage, setSourceStorage] = useState(null);
    const [selectedCustomer, selectCustomer] = useState(null);
    const [popStorage, setPopStorage] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const systemSettings = useSelector(state => state.InvoiceReducer.systemSettings);
    const settingNames = ["ProductGrouppingType", "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel"];
    const productGrouppingType = systemSettings && Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const pDefaultSalePrice = systemSettings && Array.isArray(systemSettings) ? systemSettings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue : "";
    const pDefaultSalePriceLabel = systemSettings && Array.isArray(systemSettings) ? systemSettings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue : "";

    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نوع فاکتور", colName: "InvoiceType", showInMobile: true },
        { colTitle: "شماره فاکتور", colName: "InvoiceNumber", showInMobile: false },
        { colTitle: "تاریخ فاکتور", colName: "PContactDate", showInMobile: true },
        { colTitle: "وضعیت", colName: "PInvoiceState", showInMobile: false },
        { colTitle: "طرف حساب", colName: "CustomerName", showInMobile: false },
        { colTitle: "رسمی", colName: "IsFormal", showInMobile: false, colType: "boolean" },
        { colTitle: "جمع فاکتور", colName: "InvoiceTotalPrice", colType: "currency" },
        { colTitle: "تخفیف", colName: "Discount", colType: "currency" },
        { colTitle: "مالیات", colName: "TaxFee", colType: "currency" },
        { colTitle: "سایر هزینه ها", colName: "FreightCharge", colType: "currency" },
        { colTitle: "قابل پرداخت", colName: "InvoicePureTotalPrice", colType: "currency" },
        { colTitle: "ثبت کننده", colName: "CreateByName", showInMobile: false },
        { colTitle: "تاریخ ثبت", colName: "PCreationDate", showInMobile: false },
        { colTitle: "توضیحات", colName: "Description", showInMobile: false, colType: "string", maxTextLength: 100 },
    ]
    const tableRowButtons = [
        { title: "نمایش فاکتور", type: "show", className: "group-Btn-smalll btn-secondary", onclick: rowClick, showCondition: () => isMobileApp() },
        {
            title: "چاپ فاکتور", type: "common", className: "group-Btn-smalll btn-primary", onclick: printInvoice, icon: <Printer color="#2727ff" size={18} className="rowBtn" />
        },
        {
            title: "حذف فاکتور", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف فاکتور',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteInvoice(item.InvoiceID, item.InvoiceType_, () => dispatch(searchInvoices(filterData)))
                }))
            }
        }

    ]

    function showModalProduct(e) {
        if (e.key) {
            if (e.key === "Enter" || e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        filterData.ProductID = null;
        filterData.ProductName = null;
        const setData = (data) => {
            selectProduct(data);
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData, forStorageReport: true });
    }
    function showModalCustomer(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        filterData.CustomerID = null;
        filterData.CustomerName = null;
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: true, setCustomerData: selectCustomer });
    }
    function showModalStorage(e, fieldName) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        if (fieldName === "DestStorage") {
            filterData.DestinationStorageID = null;
            filterData.DestinationStorageName = null;
        }
        else {
            filterData.SourceStorageID = null;
            filterData.SourceStorageName = null;
        }
        const onSelectStorage = (data) => {
            if (fieldName === "DestStorage") {
                setDestStorage(data);
            }
            else {
                setSourceStorage(data)
            }
        }
        setPopStorage({ show: true, setStorageData: onSelectStorage })
    }
    function showModalStaff(e) {
        if (e.key) {
            if (e.key === "Tab" || e.altKey || e.ctrlKey || e.shiftKey || !(e.key.match(/[a-z,آ-ی,' ']/i))) {
                return;
            }
            e.preventDefault();
        }
        filterData.StaffID = null;
        filterData.StaffName = null;
        setPopStaff({ show: true, forPersonnel: false, onSelect: selectStaff });
    }
    function showCreateBy() {
        filterData.CreateById = null;
        filterData.CreateByName = null;
        setPopUser({ show: true, selectUserWithName: setCreateBy });
    }
    function showUpdateBy() {
        filterData.UpdateById = null;
        filterData.UpdateByName = null;
        setPopUser({ show: true, selectUserWithName: setUpdateBy });
    }
    function searchInvoice(data) {
        let contactDateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        let contactDateTo = document.getElementsByName("ContactDateTo")[0].value;
        let creationDateFrom = document.getElementsByName("CreationDateFrom")[0].value;
        let creationDateTo = document.getElementsByName("CreationDateTo")[0].value;
        let updateDateTo = document.getElementsByName("UpdateDateTo")[0].value;
        let updateDateFrom = document.getElementsByName("UpdateDateFrom")[0].value;
        if (contactDateFrom !== '') {
            data.ContactDateFrom = dateFilters.ContactDateFrom;
        }
        if (contactDateTo !== '') {
            data.ContactDateTo = dateFilters.ContactDateTo;
        }
        if (creationDateFrom !== '') {
            data.CreationDateFrom = dateFilters.CreationDateFrom;
        }
        if (creationDateTo !== '') {
            data.CreationDateTo = dateFilters.CreationDateTo;
        }
        if (updateDateFrom !== '') {
            data.UpdateDateFrom = dateFilters.UpdateDateFrom;
        }
        if (updateDateTo !== '') {
            data.UpdateDateTo = dateFilters.UpdateDateTo;
        }
        data.Take = 10;
        data.Skip = 0;
        dispatch(searchInvoices(data));
    }
    function printInvoice(item) {
        const reportName = (item.IsFormal ? "Formal" : "") + item.InvoiceType_ + "Invoice";
        history.push({
            pathname: `/PrintViewer/${reportName}/false`,
            state: {
                dataUrl: `api/InvoiceAPI/GetInvoice?invoiceType=${item.InvoiceType_}&invoiceID=${item.InvoiceID}`,
                method: "get"
            }
        });
    }
    function rowClick(item) {
        if (item.ctrlIsDown) {
            window.open(`/Sale/Invoice/${item.InvoiceType_}/${item.InvoiceID}/${item.IsFormal}`);
        }
        else {
            history.push(`/Sale/Invoice/${item.InvoiceType_}/${item.InvoiceID}/${item.IsFormal}`)
        }
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({
            ContactDateFrom: null,
            ContactDateTo: null,
            CreationDateFrom: null,
            CreationDateTo: null,
            UpdateDateFrom: null,
            UpdateDateTo: null
        });
        setUpdateBy(null);
        setCreateBy(null);
        selectStaff(null);
        setDestStorage(null);
        setSourceStorage(null);
        selectCustomer(null);
        selectProduct(null);
        dispatch(searchInvoices({ Take: 10, Skip: 0 }));
    }
    function toExcel() {
        const url = "api/InvoiceAPI/SearchInvoice";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        setPending(true);
        exportToExcel("SearchInvoice", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-فروش و انبار";
        getInvoiceStates(setInvoiceStates);
        dispatch(getSystemSettings(settingNames));
    }, []);
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;جستجوی فاکتورها
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType} defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} />
                    <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
                    <ModalSearchStorage popData={popStorage} setStoragePoup={setPopStorage} />
                    <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                    <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                    <form readOnly onSubmit={handleSubmit(searchInvoice)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <div className="col-md-2 form-group">
                                <label>نوع فاکتور:</label>
                                <select className="search-input" defaultValue={filterData?.InvoiceType ?? ""} name="InvoiceType" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    {invoiceTypesArray.map((type, i) => <option key={i} value={type.TypeName}>{type.TypeStr}</option>)}
                                </select>
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel" title="شماره فاکتور از">شماره فاکتور از:</label>
                                <input type="text" className="search-input" name="InvoiceNumberFrom" ref={register({})} defaultValue={filterData?.InvoiceNumberFrom ?? ""} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel" title="شماره فاکتور تا">شماره فاکتور تا:</label>
                                <input type="text" className="search-input" name="InvoiceNumberTo" ref={register({})} defaultValue={filterData?.InvoiceNumberTo ?? ""} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel" title="تاریخ فاکتور از">تاریخ فاکتور از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input mt-0" name="ContactDateFrom"
                                    value={dateFilters.ContactDateFrom ? momenJalaali(dateFilters.ContactDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, ContactDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel mt-0" title="تاریخ فاکتور تا">تاریخ فاکتور تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="ContactDateTo"
                                    value={dateFilters.ContactDateTo ? momenJalaali(dateFilters.ContactDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ContactDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-2 form-group" >
                                <label>وضعیت فاکتور:</label>
                                {
                                    invoiceStates === "PENDING" &&
                                    <div className="search-input">
                                        <Loader color="#bb1370" type="BallTriangle" width={20} height={20} />
                                    </div>
                                }
                                {invoiceStates && Array.isArray(invoiceStates) &&
                                    <select className="search-input" defaultValue={filterData?.InvoiceState ?? ""} name="InvoiceState" ref={register({})}>
                                        <option value="">انتخاب کنید</option>
                                        {invoiceStates.map((s, i) => <option key={i} value={s.ID}>{s.InfoName}</option>)}
                                    </select>
                                }
                            </div>
                            <div className="col-md-2 form-group">
                                <label>طرف حساب:</label>
                                <input type="hidden" name="CustomerID" value={selectedCustomer?.ID ?? filterData?.CustomerID ?? ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={showModalCustomer}
                                    value={selectedCustomer?.Name ?? filterData?.CustomerName ?? ""} ref={register({})} name="CustomerName" />
                                <Button className="btn-input-tiny" style={{ top: 23 }} onClick={showModalCustomer}><List size={17} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>انبار مبدا:</label>
                                <input type="hidden" name="SourceStorageID" value={sourceStorage?.StorageID ?? filterData?.SourceStorageID ?? ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={e => showModalStorage(e, "SourceStorage")} name="SourceStorageName" ref={register({})}
                                    value={sourceStorage?.StorageName ?? filterData?.SourceStorageName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: 23 }} onClick={e => showModalStorage(e, "SourceStorage")} ><List size={17} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>انبار مقصد:</label>
                                <input type="hidden" name="DestinationStorageID" value={destStorage?.StorageID ?? filterData?.DestinationStorageID ?? ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={e => showModalStorage(e, "DestStorage")} ref={register({})} name="DestinationStorageName"
                                    value={destStorage?.StorageName ?? filterData?.DestinationStorageName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: 23 }} onClick={e => showModalStorage(e, "DestStorage")} ><List size={17} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>کالا:</label>
                                <input type="hidden" name="ProductID" value={selectedProduct?.ProductID ?? filterData?.ProductID ?? ""} readOnly ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={showModalProduct} name="ProductName" ref={register({})}
                                    value={selectedProduct?.ProductName ?? filterData?.ProductName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: 23 }} onClick={showModalProduct}><List size={17} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>ثبت کننده:</label>
                                <input type="hidden" name="CreateById" value={createBy?.ID ?? filterData?.CreateById ?? ""} ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={showCreateBy} name="CreateByName" ref={register({})}
                                    value={createBy?.Name ?? filterData?.CreateByName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: 23 }} onClick={showCreateBy}><List size={17} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>ویرایش کننده:</label>
                                <input type="hidden" name="UpdateById" value={updateBy?.ID ?? filterData?.UpdateById ?? ""} readOnly ref={register({})} />
                                <input type="text" className="search-input" readOnly onKeyDown={showUpdateBy} value={updateBy?.Name ?? filterData?.UpdateByName ?? ""} name="UpdateByName" ref={register({})} />
                                <Button className="btn-input-tiny" style={{ top: 23 }} onClick={showUpdateBy}><List size={17} /></Button>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>سریال کالا:</label>
                                <input type="text" className="search-input" name="ProductSerial" ref={register({})} defaultValue={filterData?.ProductSerial ?? ""} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label className="ellipsisLabel" title="فروشنده/خریدار/انباردار">فروشنده/خریدار/انباردار:</label>
                                <input type="hidden" name="StaffID" ref={register({})} value={selectedStaff?.ID ?? filterData?.StaffID ?? ""} readOnly />
                                <input type="text" className="search-input" readOnly onKeyDown={showModalStaff} value={selectedStaff?.LastName ?? filterData?.StaffName ?? ""} name="StaffName" ref={register({})} />
                                <Button className="btn-input-tiny" style={{ top: 23 }} onClick={showModalStaff}><List size={17} /></Button>
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel" title="تاریخ ثبت از">تاریخ ثبت از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreationDateFrom" removable={true}
                                    value={dateFilters.CreationDateFrom ? momenJalaali(dateFilters.CreationDateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, CreationDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel" title="تاریخ ثبت تا">تاریخ ثبت تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input mt-0" name="CreationDateTo" removable={true}
                                    value={dateFilters.CreationDateTo ? momenJalaali(dateFilters.CreationDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, CreationDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel" title="تاریخ ویرایش از">تاریخ ویرایش از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="UpdateDateFrom"
                                    value={dateFilters.UpdateDateFrom ? momenJalaali(dateFilters.UpdateDateFrom) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, UpdateDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel" title="تاریخ ویرایش تا">تاریخ ویرایش تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="UpdateDateTo"
                                    value={dateFilters.UpdateDateTo ? momenJalaali(dateFilters.UpdateDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, UpdateDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label className="ellipsisLabel" title="رسمی/عادی">رسمی/عادی:</label>
                                <select className="search-input" defaultValue={filterData?.IsFormal ?? ""} name="IsFormal" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>عادی</option>
                                    <option value={true}>رسمی</option>
                                </select>
                            </div>
                            <Col md={1} className="form-group">
                                <label className="ellipsisLabel" title="نحوه پرداخت">نحوه پرداخت:</label>
                                <select className="search-input" name="PaymentMethod" ref={register({})}
                                    defaultValue={filterData.PaymentMethod ?? ""} >
                                    <option value="" style={{ width: "100%", display: "block" }}> انتخاب کنید</option>
                                    <option value={0} style={{ width: "100%", display: "block" }}> تسویه نشده</option>
                                    <option value={1} style={{ width: "100%", display: "block" }}>نقد</option>
                                    <option value={2} style={{ width: "100%", display: "block" }}>چک و نقد</option>
                                </select>
                            </Col>                            
                            <Col md={2} className="form-group">
                                <label>قابل پرداخت: </label>
                                <input type="number" className="search-input" inputname="InvoicePureTotalPrice" defaultValue={filterData?.InvoicePureTotalPrice ?? 0} reff={register({})} />
                            </Col>
                            <Col md={2}  className="form-group">
                            <label>وضعیت تبدیل: </label>
                            <select className="search-input" name="IsConverted" ref={register({})} defaultValue={filterData.IsConverted ??""}>
                                <option value="">انتخاب کنید</option>
                                <option value={true}>تبدیل شده به فاکتور</option>
                                <option value={false}>تبدیل نشده به فاکتور</option>
                            </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>توضیحات:</label>
                                <input className="search-input" name="Description" defaultValue={filterData?.Description ?? ""} ref={register({})} />
                            </Col>
                        </Row>
                        <Button type="submit" variant="secondary" className="group-Btn-large mt-2"><Search size={17} />&nbsp;جستجوی فاکتور</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable hasPaging={true} columns={tableColes} rowButtons={tableRowButtons} filterData={filterData} searchMethod={(data) => dispatch(searchInvoices(data))}
                        reducerName="InvoiceReducer" objectName="invoiceList" rowClick={rowClick} style={{ whiteSpace: "nowrap" }} className="mt-1" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default SearchInvoice;